export default __webpack_public_path__ + "static/media/part_1_con (1).8df907ee.gif";